<template>
  <b-container fluid>
    <div class="bg-light">
      <div class="row">
        <div class="col pl-4">
          <b-form-group
            label="Select Application Category"
            v-slot="{ ariaDescribedby }"
          >
            <b-form-radio-group
              v-model="selected.status"
              @change="fetchApplications"
              :options="options"
              :aria-describedby="ariaDescribedby"
              name="radio-inline"
            ></b-form-radio-group>
          </b-form-group>
        </div>
      </div>

      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Search the table"
              ></b-form-input>

              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- get application given email start -->
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group size="sm">
              <b-form-input
                id="getApplicationGivenEmail"
                v-model="applicantEmail"
                type="text"
                placeholder="Search by email"
              ></b-form-input>

              <b-input-group-append>
                <b-button @click="getApplicationGivenEmail">Search</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!-- get application given email end -->

        <b-col md="4" class="my-1">
          <b-form-group
            label="Per page"
            label-for="per-page-select"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <!-- Main table element -->
    <div style="overflow-x: auto; width: 100%;">
      <b-table
        :busy="isBusy"
        :items="applications_data2"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        stacked="md"
        show-empty
        striped
        responsive
        small
        @filtered="onFiltered"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(name)="row">
          {{ row.item.surname }} {{ row.item.firstname }}
          {{ row.item.lastname }}
        </template>

        <template #cell(email)="row">
          {{ row.item.email }}
        </template>
        <template #cell(mobile)="row">
          {{ row.item.mobile }}
        </template>
        <template #cell(applyFor)="row">
          {{ row.item.applyFor }}
        </template>

        <template #cell(actions)="row">
          <template v-if="row.item.status == 'awaiting submission'">
            Awaiting submission</template
          >
          <template v-else-if="!row.item.status"> No application yet</template>
          <template v-else-if="row.item.status == 'recommendation queried'">
            <button
              class="btn btn-sm btn-outline-warning"
              @click="showQueryModal(row.item)"
            >
              View Query Message
            </button>
          </template>
          <template
            v-else-if="
              row.item.status &&
                row.item.status != 'awaiting submission' &&
                row.item.status != 'recommendation queried'
            "
          >
            <template v-if="wantToPrintLetter">
              <button
                class="btn btn-sm btn-outline-primary"
                @click="admissionLetter(row.item.admissionLetter)"
              >
                Admission Letter
              </button>
              <button
                class="btn btn-sm btn-outline-primary"
                @click="reverseAdmission(row.item)"
              >
                Reverse Admission
              </button>
              <admission-letter></admission-letter>
            </template>
            <template v-else>
              <button
                class="btn btn-sm btn-outline-dark"
                @click="viewApplicant(row.item, row.index, $event.target)"
              >
                view
              </button>
              <print-all
                :application_number="row.item.application_number"
                :applicantData="row.item"
                :applicantName="row.item.surname + ' ' + row.item.firstname"
                :mobile="row.item.mobile"
                :email="row.item.email"
                :applicationId="row.item.id"
              />
              <template v-if="$store.state.user.roleInUse != 'pgCoord'">
                <accept-admission :index="row.index" :item="row.item" />
              </template>
              <button
                class="btn btn-outline-dark rounded btn-sm"
                v-b-tooltip.hover
                title="Download All Credentials"
                @click="downloadAll(row.item)"
              >
                <b-icon icon="download" scale="1"></b-icon>
              </button>
            </template>
          </template>
        </template>
        <template #empty="">
          <h4 class="text-danger text-center">No record</h4>
        </template>
        <template #emptyfiltered="">
          <h4 class="text-danger text-center">
            The record you searched for is not avalable
          </h4>
        </template>
      </b-table>
      <!-- Main table element end -->
    </div>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRecords || totalRows"
          :per-page="perPage"
          class="my-0"
          @change="loadApplications"
        ></b-pagination>
      </b-col>
      <b-col md="6" class="my-1 text-right">
        <small class="text-muted">{{ totalRecords || totalRows }} total records</small>
      </b-col>
    </b-row>
    <!-- App Recommendation Modal -->
    <app-recommendation-modal />
    <!-- App Recommendation Modal end -->

    <!-- Query Message Modal -->
    <b-modal
      id="query-message-modal"
      ref="queryMessageModal"
      v-model="showQueryMessageModal"
      title="Recommendation Query"
      centered
      ok-only
      ok-title="Close"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="p-3" v-if="selectedApplication">
        <h6>Application Details:</h6>
        <p>
          <strong>Name:</strong> {{ selectedApplication.surname }}
          {{ selectedApplication.firstname }}
        </p>
        <p><strong>Email:</strong> {{ selectedApplication.email }}</p>
        <p><strong>Programme:</strong> {{ selectedApplication.programme }}</p>

        <hr />

        <div class="query-section">
          <h6 class="mb-3">
            <b-icon
              icon="exclamation-triangle"
              variant="danger"
              class="mr-2"
            ></b-icon>
            Query Message
          </h6>

          <div
            class="alert alert-danger border-left-danger shadow-sm"
            role="alert"
          >
            <div class="alert-content">
              <b-icon icon="chat-quote" class="mr-2 text-danger"></b-icon>
              <span class="query-text">
                {{
                  selectedApplication.pg_comment ||
                    "No query message available."
                }}
              </span>
            </div>
          </div>

          <div class="query-meta mt-3 p-3 bg-light rounded">
            <div class="d-flex align-items-center">
              <b-icon icon="clock" class="mr-2 text-muted"></b-icon>
              <small class="text-muted mb-0">
                <strong>Queried on:</strong>
                <span class="ml-1">
                  {{
                    selectedApplication.pg_comment_at
                      ? new Date(
                          selectedApplication.pg_comment_at
                        ).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      : "Date not available"
                  }}
                </span>
              </small>
            </div>
          </div>
        </div>

        <!-- Button start -->
        <button
          class="btn btn-sm btn-outline-danger mr-1"
          @click="reset_recommendation_status(selectedApplication)"
          v-b-tooltip.hover
          title="Reset for action"
        >
          <b-icon icon="pencil" scale="1"></b-icon>
        </button>
        <button
          class="btn btn-sm btn-outline-warning mr-1"
          @click="addComment(selectedApplication)"
          v-b-tooltip.hover
          title="Add Comment"
        >
          <b-icon icon="chat-dots" scale="1"></b-icon>
        </button>
        <button
          class="btn btn-sm btn-outline-info"
          @click="sendEmail(selectedApplication)"
          v-b-tooltip.hover
          title="Send Email"
        >
          <b-icon icon="envelope" scale="1"></b-icon>
        </button>
        <!-- Button end -->
      </div>
    </b-modal>
    <!-- Query ends -->

    <select-settings-modal />
    <email-component ref="emailComponent" :recipient="selectedApplication" />
  </b-container>
</template>

<script>
import { isEmpty } from "lodash";

import EmailComponent from "@/components/application/helper/email.component.vue";
import AcceptAdmission from "./accept.admission.vue";
import PrintAll from "../Forms/print.all.vue";
import AdmissionLetter from "./admissionLetter.vue";
import SelectSettingsModal from "../../helper/selectSettings.modal.vue";
import appRecommendationModal from "../../helper/appRefereeModal.vue";
export default {
  // props: ["applications"],
  components: {
    EmailComponent,
    AcceptAdmission,
    PrintAll,
    AdmissionLetter,
    SelectSettingsModal,
    appRecommendationModal,
  },
  data() {
    return {
      // applications:
      selected: {
        status: "submitted under processing",
      },
      options: [
        { text: "All ", value: "all" },
        { text: "Submitted ", value: "submitted under processing" },
        { text: "Pending ", value: "awaiting submission" },
        { text: "Denied  ", value: "denied" },
        { text: "Approved ", value: "approved" },
        { text: "Recommended", value: "recommended" },
        { text: "Not Recommended", value: "nrecommended" },
      ],
      isBusy: false,
      fields: [
        {
          key: "name",
          label: "Full Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "mobile",
          label: "Mobile",
          sortable: true,
        },
        {
          key: "programme",
          label: "Programme",
          sortable: true,
          formatter: (value) => {
            if (!value) return "-";
            return typeof value === "object" ? value.programme || "-" : value;
          },
        },
        {
          key: "approvedProgramme",
          label: "Approved Programme",
          sortable: true,
          formatter: (value) => {
            if (!value) return "-";
            return typeof value === "object" ? value.programme || "-" : value;
          },
        },
        {
          key: "applyFor",
          label: "Applied For",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Date Applied",
          sortable: true,
          formatter: (value) => {
            if (!value) return "-";
            return new Date(value).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
          },
        },
        {
          key: "recommended_at",
          label: "Date Recommended",
          sortable: true,
          formatter: (value) => {
            if (!value) return "-";
            return new Date(value).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
          },
        },
        {
          key: "approved_at",
          label: "Date Approved",
          sortable: true,
          formatter: (value) => {
            if (!value) return "-";
            return new Date(value).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
          },
        },
        {
          key: "status",
          label: "Admission Status",
          sortable: true,
        },
        { key: "actions", label: "Actions" },
      ],
      totalRows: 0,
      totalRecords: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 25, 50],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      wantToPrintLetter: false,
      applications_data2: [],
      applicantEmail: "",
      showQueryMessageModal: false,
      selectedApplication: null,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    applications_data() {
      return this.$store.state.AdmissionOfficer.applications;
    },
  },
  methods: {
    showRecommendations(application) {
      // Trigger the recommendation modal
      Fire.$emit("SHOW-RECOMMENDATIONS", application.id);
    },
    sendEmail(item) {
      this.selectedApplication = item;
      this.$refs.emailComponent.openModal({
        to: item.email,
        subject: `RE: Application — ${item.surname} ${item.firstname}`,
      });
    },
    showQueryModal(item) {
      this.selectedApplication = item;
      this.showQueryMessageModal = true;
    },
    loadSettings() {
      this.$store
        .dispatch("getSettings")
        .then((response) => {
          // this.programmes = response
        })
        .catch((err) => {
          console.log(err);
        });
    },
    admissionLetter(letter) {
      Fire.$emit("SHOW-ADMISSION-LETTER", letter);
    },
    fetchApplications() {
      this.currentPage = 1;
      this.loadApplications();
    },
    printAll() {},
    downloadFile(file) {
      return new Promise((res, rej) => {
        axios({
          url: "admin/downloadFile",
          methods: "GET",
          params: { path: file.path },
          responseType: "blob",
        })
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", file.name);
            document.body.appendChild(fileLink);
            fileLink.click();
            res(true);
          })
          .catch((err) => {
            console.log(err);
            rej(err);
          });
      });
    },
    downloadAll(item) {
      this.$store.dispatch("spinner/showSpinner");
      let credentials = "";
      let assessment = "";
      this.$store
        .dispatch("AdmissionOfficer/getForms", item.id)
        .then((response) => {
          // this.busy.state = false;
          credentials = response.data.credentials;
          assessment = response.data.assessment;
          this.downloadFile(assessment.essay);
          credentials.credentials.forEach(async (element) => {
            await this.downloadFile(element);
          });
          this.$store.dispatch("spinner/hideSpinner");
        })
        .catch((err) => {
          // this.busy.state = false;
          console.log(err);
        });
      console.log(item);
    },
    selectProgramme() {
      this.$store
        .dispatch("getProgrammes")
        .then((response) => {
          // this.programmes = response
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadDepartments() {
      this.$store
        .dispatch("getDepartments")
        .then((response) => {
          // this.departments = response
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    viewApplicant(item, index, target) {
      let applicationId = item.id;
      let applicant = item.surname + " " + item.firstname + " " + item.lastname;
      Fire.$emit("VIEW-APPLICANT", {
        applicationId: applicationId,
        applicantName: applicant,
        email: item.email,
        mobile: item.mobile,
        applicantData: item,
        application_number: item.application_number,
      });
    },

    addComment(item) {
      Swal.fire({
        title: "Add Comment",
        html: `<p class="text-left mb-2"><strong>${item.surname} ${item.firstname}</strong> — ${item.programme ? (typeof item.programme === 'object' ? item.programme.programme : item.programme) : ''}</p>`,
        input: "textarea",
        inputPlaceholder: "Enter your comment...",
        inputAttributes: { "aria-label": "Comment" },
        showCancelButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        inputValidator: (value) => {
          if (!value) return "Please enter a comment";
        },
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          axios
            .post("/admin/pg_comment_for_department", {
              applicationId: item.id,
              query_msg: result.value,
            })
            .then((res) => {
              this.showToast("success", res.data.message || "Comment added successfully");
              this.loadApplications();
            })
            .catch((err) => {
              this.showToast("error", err.response ? err.response.data.message : "Failed to add comment");
            });
        }
      });
    },

    reset_recommendation_status(item) {
      const swalOptions = {
        title: "You are about to reset the recommendation actions",
        text: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "YES",
        cancelButtonText: "NO",
      };

      Swal.fire(swalOptions).then((result) => {
        if (result.isConfirmed) {
          const details = { application_id: item.id };
          this.$store
            .dispatch("AdmissionOfficer/reset_recommendation_status", details)
            .then((res) => {
              Fire.$emit("acceptAdmission");
              this.showToast("info", res.data.message);
              this.$store.dispatch("spinner/hideSpinner");
            })
            .catch((err) => {
              Toast.fire({
                icon: "error",
                title: err.response.data.message,
              });
            });
        } else {
          this.showToast("info", "Operation Cancelled");
        }
      });
    },
    loadApplications(page) {
      if (page) this.currentPage = page;
      this.isBusy = true;
      this.$store
        .dispatch("AdmissionOfficer/getPaginatedApplications", {
          status: this.selected.status,
          currentPage: this.currentPage,
          perPage: this.perPage,
        })
        .then((response) => {
          this.applications_data2 = response.applications || response;
          this.totalRecords = response.totalRecord || this.applications_data2.length;
          this.totalRows = this.applications_data2.length;
          this.wantToPrintLetter = this.selected.status === "approved";
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          Toast.fire({
            icon: "error",
            title: err.error || "Failed to load applications",
          });
        });
    },
    getApplicationGivenEmail() {
      if (isEmpty(this.applications)) {
        this.isBusy = true;
      }
      this.isBusy = true;

      this.$store
        .dispatch("AdmissionOfficer/getApplicationGivenEmail", {
          applicantEmail: this.applicantEmail,
        })
        .then((response) => {
          this.applications_data2 = response;
          this.totalRows = this.applications_data2.length;
          if (this.selected.status == "approved") {
            this.wantToPrintLetter = true;
          } else {
            this.wantToPrintLetter = false;
          }
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          Toast.fire({
            icon: "error",
            title: err.error,
          });
        });
    },
    reverseAdmission(item) {
      const swalOptions = {
        title:
          "You are about to reset admission approval for this application!",
        text: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "YES",
        cancelButtonText: "NO",
      };

      Swal.fire(swalOptions).then((result) => {
        if (result.isConfirmed) {
          const details = { application_id: item.id };
          this.$store
            .dispatch(
              "AdmissionOfficer/reset_application_for_pg_actions",
              details
            )
            .then((res) => {
              Fire.$emit("acceptAdmission");
              this.showToast("info", res.data.message);
              this.$store.dispatch("spinner/hideSpinner");
            })
            .catch((err) => {
              this.showToast("info", "Failed to reset application");
            });
        } else {
          this.showToast("info", "Operation Cancelled");
        }
      });
    },
    showToast(icon, title) {
      Toast.fire({ icon, title });
    },
  },
  watch: {
    perPage() {
      this.currentPage = 1;
      this.loadApplications();
    },
  },
  mounted() {
    this.selectProgramme();
    this.loadSettings();
    this.loadDepartments();
  },
  created() {
    this.loadApplications();
    Fire.$on("acceptAdmission", () => {
      this.loadApplications();
    });
  },
};
</script>

<style scoped>
.query-section {
  margin: 1rem 0;
}

.border-left-danger {
  border-left: 4px solid #dc3545 !important;
}

.alert-content {
  display: flex;
  align-items: flex-start;
  line-height: 1.5;
}

.query-text {
  flex: 1;
  word-wrap: break-word;
  font-size: 0.95rem;
}

.query-meta {
  background-color: #f8f9fa !important;
  border: 1px solid #e9ecef;
}

.query-meta small {
  font-size: 0.875rem;
}

/* Enhanced alert styling */
.alert-danger {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
  margin-bottom: 0;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .alert-content {
    flex-direction: column;
  }

  .alert-content .bi {
    margin-bottom: 0.5rem;
  }
}
</style>
